module.exports = "<div class=\"spinner-box\">\n    <div class=\"spinner-child-box\">\n        <div class=\"label\">{{ message }}</div>\n        <div class=\"spinner\"><div class=\"spinner-icon\"></div></div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/components/app-spinner-div/app-spinner-div.component.html
// module id = ../../../../../angular/app/components/app-spinner-div/app-spinner-div.component.html
// module chunks = main